import {IMutableGridModel} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import * as React from 'react';
import * as classnames from 'classnames/bind';
import {AutoGridView} from '@mintdata-wsp/wsp/ui/components/grid/AutoGridView';
import {observable} from 'mobx';
import {observer} from 'mobx-react';
import bind from 'bind-decorator';

const styles = require('./CellPopupView.less');
const cx = classnames.bind(styles);

export interface CellPopupViewProps
{
    width:number;
    height:number;
    gridModel:IMutableGridModel;
}

@observer
export class CellPopupView extends React.Component<CellPopupViewProps, any>
{
    @observable
    private _isMeasureDone:boolean = false;

    @bind
    private _onMeasureDone()
    {
        this._isMeasureDone = true;
    }

    render()
    {
        const {gridModel, width, height} = this.props;
        const style:any = {
                                width:width,
                                minWidth:width,
                                height:height,
                                minHeight:height,
                          };

        return  <div className={cx( 'cellPopup',
                                    // {'hidden':!this._isMeasureDone},
                                  )} style={style}>

                    <AutoGridView className={cx('popupGrid')} gridModel={gridModel}/>

                    <div className={cx('arrowDown')}/>

                </div>;
    }
}
